import type { OnboardingScenarioProps } from '../model/types'
import { useBreakUpOnboarding } from '../model/useBreakUpOnboarding'
import { promises, recencyOptions, situations } from '../model/breakUp.data'
import s from './BreakUpOnboarding.module.css'
import BreakUpIntroduction from './BreakUpIntroduction'

export default function BreakUpOnboarding(props: OnboardingScenarioProps) {
  const flow = useBreakUpOnboarding(props)
  return (
    <div className={s.page}>
      <header className={s.header}>
        <span className={s.brandWrap}>
          <span className={s.brand}>Хьюмантек</span>
          <span className={s.brandRole}>ИИ-сопровождение в расставаниях</span>
        </span>
        <span aria-live="polite">Шаг {flow.step + 1} из 3</span>
      </header>
      <div className={s.progress} aria-hidden="true"><span style={{ width: `${((flow.step + 1) / 3) * 100}%` }} /></div>
      <main className={s.main}>
        <section className={s.card} key={flow.step} ref={flow.screenRef} tabIndex={-1}>
          {flow.step === 0 && <BreakUpIntroduction {...flow} />}
          {flow.step === 1 && <>
            <h1 className={s.heading}>Что сейчас происходит?</h1>
            <p className={s.subtitle}>Выберите то, что ближе всего. Это поможет начать с нужного места.</p>
            <fieldset className={s.field}>
              <legend>Можно выбрать несколько:</legend>
              <div className={s.chips}>
                {situations.map((situation) => <button key={situation} type="button" value={situation} aria-pressed={flow.tags.includes(situation)} onClick={flow.toggleSituation}>{situation}</button>)}
              </div>
            </fieldset>
            <fieldset className={s.field}>
              <legend>Как давно произошло расставание?</legend>
              <div className={`${s.options} ${s.recency}`}>
                {recencyOptions.map((option) => <label key={option}><input type="radio" name="recency" value={option} checked={flow.recency === option} onChange={flow.changeRecency} /><span>{option}</span></label>)}
              </div>
            </fieldset>
          </>}
          {flow.step === 2 && <>
            <h1 className={s.heading}>Мы начнём с вашей текущей ситуации</h1>
            <ul className={s.promises}>{promises.map((promise) => <li key={promise}>{promise}</li>)}</ul>
          </>}
        </section>
        {props.error && <p className={s.error} role="alert">{props.error}</p>}
        <div className={s.actions}>
          {flow.step > 0 && <button type="button" className={s.back} onClick={flow.goBack} disabled={props.submitting}>Назад</button>}
          <button type="button" className={s.next} onClick={flow.goNext} disabled={!flow.canContinue || props.submitting}>
            {props.submitting ? 'Сохраняем…' : flow.step === 2 ? 'Начать восстановление' : 'Продолжить'}
          </button>
        </div>
      </main>
    </div>
  )
}
